module.exports = __webpack_public_path__ + "static/img/fa55bffc8f9a7b79f7794383891a8db4.80f0355d.jpg";